export const getDMSFeatureFlag = () => { return localStorage.getItem("IS_DMS_ENABLED")? JSON.parse(localStorage.getItem("IS_DMS_ENABLED")) : true;}
